import "@hotwired/turbo-rails"
import "./controllers"

Turbo.StreamActions.redirect = function () {
  window.location.href = this.target
}
